import { AutogenModelAgentAccessCtrl, AutogenRowAgentAccessCtrl } from "./autogen/AutogenModelAgentAccessCtrl";

export class ModelAgentAccessCtrl extends AutogenModelAgentAccessCtrl<RowAgentAccessCtrl> {
    constructor() {
        super(RowAgentAccessCtrl);
    }
}

export class RowAgentAccessCtrl extends AutogenRowAgentAccessCtrl {
}